import colors from "../../../../constants/colorConstants";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import BaseHeading from "../../../../baseComponents/baseHeading";
import BaseParagraph from "../../../../baseComponents/baseParagraph";
import BaseInput from "../../../../baseComponents/baseInput";
import BaseButton from "../../../../baseComponents/baseButton";
import { useState, useEffect } from "react";
import {
  action as userActions,
  asyncActions as userAsyncActions,
} from "../../../../store/slices/userSlice.js";
import {asyncActions as successAsyncActions} from "../../../../store/slices/successSlice.js";
import useBootstrap from "../../../../customHooks/useBootstrap";
import useColors from "../../../../customHooks/useColors";


const MyCardRightSide = ({}) => {

  //////////////////////////////////////////////////////////////DISPATCHER
  const dispatch = useDispatch();

  //////////////////////////////////////////////////////////////THEME
  const [currentColors] = useColors();

  //////////////////////////////////////////////////////////////REDUX STATE
  const userState = useSelector((state) => state.userState);

  //////////////////////////////////////////////////////////////LOCAL STATES
  const [cardCode, setCardCode] = useState("");
  const [error, setError] = useState("");

  //////////////////////////////////////////////////////////////STATE DRIVEN VARIABLES
  const physicalCards = userState.physicalCards;
  const physicalCardsNumber = physicalCards.length;
  const customerHasPhysicalCards = physicalCardsNumber > 0;

  //////////////////////////////////////////////////////////////STYLES
  const styles = {
    leftContainer: {
      backgroundColor: currentColors.septenary,
      padding: "1em",
      display: "flex",
      flexDirection: "column",
      gap: "1em",
    },
    rightContainer: {
      backgroundColor: currentColors.septenary,
      padding: "1em",
      display: "flex",
      flexDirection: "column",
      gap: "1em",
    },
  };


  const {trashold4} = useBootstrap();

  //////////////////////////////////////////////////////////////HANDLING FUNCTIONS
  const handleCardCode = (e) => {
    clearErrorMsg();
    setCardCode(e.target.value);
  };

  //////////////////////////////////////////////////////////////METHODS
  const givePhysicalCardToCustomer = async () => {
     dispatch(
      userAsyncActions.connectCardAndCustomer({ cardNumber: cardCode, setErrorMsg : setError })
    );
   
  };

  const clearErrorMsg = () => {
    setError("");
  }

  return (
    <Container style={{ marginTop: "1em" }}>
      {customerHasPhysicalCards === false && (
        <Row className="g-0">
          <Col {...trashold4}>
            <div style={styles.leftContainer} className="h-100">
              <BaseHeading h3 bold>
                alreadyHaveCardQuestion
              </BaseHeading>
              <BaseParagraph>connectCardMessage</BaseParagraph>
              
            </div>
          </Col>
          <Col {...trashold4}>
            <div style={styles.rightContainer} className="h-100">
           
              <BaseHeading h3 bold style={{  }}>
              </BaseHeading>
              <BaseInput
                value={cardCode}
                onChange={(e) => {
                  handleCardCode(e);
                }}
                onEnter = {(e) => {
                  givePhysicalCardToCustomer();
                }}
                placeholder="cardNumber"
              />
              <BaseButton error = {error} onClick={givePhysicalCardToCustomer}>
                connectCard
              </BaseButton>
            </div>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default MyCardRightSide;
